export default __webpack_public_path__ + "static/media/cloture-barn.8cfe3578.png";